import { Navigate, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

// project imports
import { useAuth } from 'contexts/AuthContext';

// ==============================|| PROTECTED ROUTE GUARD ||============================== //

/**
 * Protected route component that redirects to login if not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading or spinner while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children or outlet
  return children || <Outlet />;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node
};

export default ProtectedRoute;
